import React from 'react'
import { baseUrl } from '../../Axios';
import * as InterialStyle from "../../styles/dabin/StyledComponenetInterialRenewal";

// 브랜드 로고
import logo_verpan from "../../images/interiorRenewalSplash/logo_verpan.png"
import logo_luceplan from "../../images/interiorRenewalSplash/logo_luceplan.png"
import logo_artemide from "../../images/interiorRenewalSplash/logo_artemide.png"
import logo_lyfa from "../../images/interiorRenewalSplash/logo_lyfa.png"
import logo_vibia from "../../images/interiorRenewalSplash/logo_vibia.png"
import logo_flos from "../../images/interiorRenewalSplash/logo_flos.png"

// 이미지
import image_01 from "../../images/interiorRenewalSplash/image_01.png"
import image_02 from "../../images/interiorRenewalSplash/image_02.png"
import image_03 from "../../images/interiorRenewalSplash/image_03.png"

const logos = [logo_verpan,logo_luceplan,logo_artemide,logo_lyfa,logo_vibia,logo_flos]
const images = [image_02, image_03, image_01]

const InteriorRenewalHeroSection = () => {
  return (
    <div>
      <InterialStyle.InteriorRenewalHeroSectionContainer>
        <div className="hero-section-text-box">
          <img className='hero-section_logo' 
            src={`${baseUrl}files/image_folder/alc_service_images/812df428702e8781bde700aba346898f1dfac97d9fefc1efb3168a00e7c094f7ad6bf7bfe5bb8ab2c72da483291770111f9d03efaac5b6559ddf2095486a53f5.png`}
            alt="logo" 
          />
          <h1>국내 유일 하이엔드 조명 플랫폼, AOS</h1>
          <h2><span>250여 인테리어 전문가들이 선택한 AOS,</span>지금 직접 경험해보세요.</h2>
          <div className="hero-section-brand-logos">
            <ul>
              {logos.map((tmp, idx) => {
                return (
                  <li key={idx}>
                    <img className='hero-section-brand-logo' 
                      src={`${tmp}`}
                      alt="logo" 
                    />
                  </li>
                )
              })}
            </ul>
          </div>
          <div className="hero-section_images">
            <ul>
              {images.map((tmp, idx) => {
                return (
                  <li key={idx}>
                    <img className='hero-section_image' 
                      src={`${tmp}`}
                      alt="images" 
                    />
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </InterialStyle.InteriorRenewalHeroSectionContainer>
    </div>
  )
}

export default InteriorRenewalHeroSection